import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllSemestersUserUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllSemestersUser
  implements GetAllSemestersUserUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllSemestersUserUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetAllSemestersUserUseCaseInterface.Params,
  ): Promise<GetAllSemestersUserUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        entity: params?.entityId,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
